import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { StoreDetailsLayout } from '~/components/routes/stores/StoreDetailsLayout'
import { InventoriesStatsTab } from '~/components/routes/stores/inventories/InventoriesStatsTab'
import { STORE_TAB_PERMISSIONS } from '~/components/routes/stores/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/stores/$storeId/stats')({
  staticData: {
    permission: STORE_TAB_PERMISSIONS.stats,
  },
  component: StoreStatisticsTab,
  params: {
    parse: z.object({ storeId: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function StoreStatisticsTab() {
  const { storeId } = Route.useParams()

  return (
    <StoreDetailsLayout storeId={storeId} tab="stats">
      <InventoriesStatsTab shopId={storeId} />
    </StoreDetailsLayout>
  )
}
